import { Button, Heading, Text } from '@everlywell/ui-kit';
import SectionContainer from 'components/PageSections/components/SectionContainer';
import React from 'react';

import FaqAccordion, {
  FaqAccordionSlotOverrides,
  FaqItem,
} from './components/FaqAccordion';

type SlotOverride = {
  sx?: any;
};

export type FaqV2SlotOverrides = {
  root?: SlotOverride;
  eyebrow?: SlotOverride;
  title?: SlotOverride;
  accordion?: FaqAccordionSlotOverrides;
};

export interface FaqV2Props {
  eyebrow: string;
  title: string;
  faqs: FaqItem[];
  sx?: any;
  slots?: FaqV2SlotOverrides;
  isNewPdp?: boolean;
}

const FaqV2: React.FC<FaqV2Props | null> = (props) => {
  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);
  if (!props) {
    return null;
  }

  const { faqs, eyebrow, title, sx, slots, isNewPdp } = props;

  const sectionSx = {
    ...(sx || {}),
    ...(slots?.root?.sx || {}),
  };

  // New-design PDPs show the full FAQ list (no "View more" truncation).
  const showAllFaqs = Boolean(isNewPdp) || isExpanded;

  return (
    <SectionContainer
      size={['sm', 'sm', 'md', 'lg']}
      centerContent
      sx={sectionSx}
    >
      <Text
        marginBottom={['1', '2']}
        marginX="auto"
        size="lg"
        color="viridian.base"
        textAlign="center"
        sx={slots?.eyebrow?.sx}
      >
        {eyebrow}
      </Text>
      <Heading
        marginX="auto"
        as="h2"
        // @ts-ignore
        size={['32px', '2xl']}
        marginBottom={[10, 16]}
        textAlign="center"
        sx={slots?.title?.sx}
      >
        {title}
      </Heading>

      <FaqAccordion
        faqs={faqs}
        width={['100%', '100%', '100%', '1024px']}
        isExpanded={showAllFaqs}
        slots={slots?.accordion}
      />
      {!isNewPdp && faqs && faqs.length > 5 && (
        <Button
          height={['40px', '52px']}
          marginTop={[10, '60px']}
          onClick={() => setIsExpanded((prevState) => !prevState)}
        >
          <Text color="tints.white" fontWeight="medium" size="lg">
            {!isExpanded ? 'View more' : 'Collapse'}
          </Text>
        </Button>
      )}
    </SectionContainer>
  );
};

export default FaqV2;
